/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { styled } from '@mui/system';

export const AgreementsContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
});

